import { MarkdownEditorField } from '@/components/markdown/markdown-editor-field'
import {
  Card,
  CardContent,
} from '@/components/ui/card'
import { useAuth } from '@/hooks/use-auth'
import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import { CardHeaderWithBadge } from './-components/card-header-with-badge'
import { useCompanyFieldForm } from './-components/use-company-field-form'

const parentRoute = getRouteApi('/_authed/_user/organization')

export const Route = createFileRoute(
  '/_authed/_user/organization/offering',
)({
  component: OfferingSection,
  beforeLoad: () => ({
    getTitle: () => 'Offering',
    getDescription: () => 'Describe what your company offers and the value it provides to customers',
  }),
})

function OfferingSection() {
  const { canEditOrgSettings: canEdit } = useAuth()
  const { initialData, hasCompanyInfo } = parentRoute.useLoaderData()

  const { form, NavBlocker } = useCompanyFieldForm({
    fieldName: 'qualificationArguments',
    initialData,
  })

  return (
    <>
      <Card data-tour="org-offering-card" className={canEdit ? '' : 'opacity-75'}>
        <CardHeaderWithBadge
          title="Value Proposition"
          description="Describe your company's main offering and the value it provides to customers."
          form={form}
          fieldName="qualificationArguments"
          hasCompanyInfo={hasCompanyInfo}
        />
        <CardContent>
          <MarkdownEditorField
            form={form}
            name="qualificationArguments"
            displayModeByDefault
            placeholder="Describe your company's main offering and value proposition..."
            disabled={!canEdit}
            showSaveButton={canEdit}
            onSave={() => form.handleSubmit()}
          />
        </CardContent>
      </Card>
      <NavBlocker />
    </>
  )
}
